import { Mail, Coins, X } from "lucide-react";

export default function MemberRow({ member, onTransfer, onRemove }) {
  const isPending = member.status === "invited";
  return (
    <div
      data-testid={`team-member-${member.id}`}
      className="grid grid-cols-12 items-center px-5 py-4 border-b border-white/5 last:border-b-0 hover:bg-white/[0.02] transition"
    >
      <div className="col-span-5">
        <div className="text-sm text-white">{member.name || member.email}</div>
        <div className="text-[11px] text-white/45 flex items-center gap-2 mt-0.5">
          <span>{member.email}</span>
          {isPending && (
            <span className="inline-flex items-center gap-1 text-[9px] uppercase tracking-[0.18em] text-amber-300 bg-amber-500/10 border border-amber-400/30 rounded-full px-1.5 py-0.5">
              <Mail className="w-2 h-2" /> Invited
            </span>
          )}
        </div>
      </div>
      <div className="col-span-2 text-right text-sm text-white/75">
        {member.credits_allocated.toFixed(member.credits_allocated % 1 === 0 ? 0 : 1)}
      </div>
      <div className="col-span-2 text-right">
        <span className="text-sm text-[#D4AF37] font-medium">
          {member.credits_balance.toFixed(member.credits_balance % 1 === 0 ? 0 : 1)}
        </span>
      </div>
      <div className="col-span-3 flex justify-end gap-1.5">
        <button
          type="button"
          onClick={onTransfer}
          data-testid={`team-member-${member.id}-transfer`}
          className="inline-flex items-center gap-1 text-[11px] px-2.5 py-1.5 rounded-full bg-[#D4AF37]/15 text-[#D4AF37] hover:bg-[#D4AF37]/25 transition"
        >
          <Coins className="w-3 h-3" /> Credits
        </button>
        <button
          type="button"
          onClick={onRemove}
          data-testid={`team-member-${member.id}-remove`}
          title="Remove from team"
          className="inline-flex items-center text-[11px] px-2 py-1.5 rounded-full border border-white/10 text-white/55 hover:text-rose-300 hover:border-rose-400/35 transition"
        >
          <X className="w-3 h-3" />
        </button>
      </div>
    </div>
  );
}
